/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, OrganizationTeamMember, TeamMemberRole, UpdateMembersInOrganizationTeam } from "./data-contracts";

/**
 * @description Updates members of an organization team, either adding or removing them. If a the same user is included as both an add and a remove, they will be removed from the team.
 * @tags team-members
 * @name UpdateMembersInOrganizationTeam
 * @summary Updates members of a team
 * @request PUT:/orgs/{organizationId}/teams/{teamId}/members
 * @secure
 */

// @ts-ignore
export const updateMembersInOrganizationTeam: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the Team */
    teamId: string;
  };
  RequestQuery: {};
  RequestBody: UpdateMembersInOrganizationTeam;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/teams/{teamId}/members",
  method: "put",
  streaming: false,
  tags: ["team-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists members, and their roles, for the specified organization team.
 * @tags team-members
 * @name ListTeamMembersInOrganizationById
 * @summary List all team members
 * @request GET:/orgs/{organizationId}/teams/{teamId}/members
 * @secure
 */

// @ts-ignore
export const listTeamMembersInOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the Team */
    teamId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationTeamMember[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/teams/{teamId}/members",
  method: "get",
  streaming: false,
  tags: ["team-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Add or updates member in the specified organization team.
 * @tags team-members
 * @name AddMemberToOrganizationTeamById
 * @summary Add a team member
 * @request PUT:/orgs/{organizationId}/teams/{teamId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const addMemberToOrganizationTeamById: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the Team */
    teamId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * "The role of a team member.
     * "owner": Can manage team members.
     * "member": Is a member of the team.
     */
    role?: TeamMemberRole;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/teams/{teamId}/members/{userId}",
  method: "put",
  streaming: false,
  tags: ["team-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Deletes member from the specified organization team.
 * @tags team-members
 * @name DeleteMemberFromOrganizationTeamById
 * @summary Delete a team member
 * @request DELETE:/orgs/{organizationId}/teams/{teamId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const deleteMemberFromOrganizationTeamById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the Team */
    teamId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/teams/{teamId}/members/{userId}",
  method: "delete",
  streaming: false,
  tags: ["team-members"],
  criticalityLevel: "low",
  deprecated: false,
};
